import { NamedRoutes } from "./NamedRoutes";
export class PatientDeleteMyAccountConfirmationViewModel {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
    }
    onTalkToUsClicked() {
        window.open("https://www.healthex.io/contact-us", "_blank");
        this.routingUIManager.redirectTo(NamedRoutes.LOGIN_AS_PATIENT);
    }
}
